import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { useWapp } from '$logic/wapps/react-hook'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'

const StyledTypography = styled(Typography)`
  margin-right: 4px;
  display: contents;
`

export function WappRoomListItemTitle({ wappId }: { wappId: string }) {
  const { entity: wapp } = useWapp(wappId)

  return (
    <WithQueryTitleWrapper>
      <StyledTypography variant="subtitle3" noWrap>
        {wapp?.name}
      </StyledTypography>
    </WithQueryTitleWrapper>
  )
}
